(function () {
    if (window.__personasCarouselHasFired) {
      return;
    }

    window.Branch = window.Branch || {};
    window.Branch.personasCarousel = window.Branch.personasCarousel || {};
    window.Branch.personasCarousel.sliders = window.Branch.personasCarousel.sliders || {};
    window.__personasCarouselHasFired = true;

    // Center ("click") the persona slide a personalization nominates, if any. Each carousel carries
    // a server-rendered handle→slide-handle map (data-personalization-default-slide-map). Called on
    // load (handle null → use the live/active handle) and on branch:personalization-updated (handle
    // provided). No-op when there's no active personalization or no mapped slide. See
    // _drafts/personalizations.md.
    window.Branch.personasCarousel.goToPersonalizationDefaultSlide = function(personalizationHandle, carouselEl){
        const carousels = carouselEl ? [carouselEl] : document.querySelectorAll('.personas-carousel');
        carousels.forEach(carousel => {
            let map;
            try { map = JSON.parse(carousel.getAttribute('data-personalization-default-slide-map') || '{}'); }
            catch (e) { return; }
            // Explicit handle (client-side update) wins; else the live handle set by a prior
            // client-side trigger; else the server-resolved handle rendered in on load.
            let handle = personalizationHandle;
            if (handle == null) {
                handle = (window.Branch.personalization && window.Branch.personalization.activeHandle) || carousel.getAttribute('data-active-personalization');
            }
            if (!handle) return;
            const targetTitleHandle = map[handle];
            if (!targetTitleHandle) return;
            const parent = carousel.closest('.shopify-section');
            if (!parent) return;

            const activeHandleOf = () => {
                const a = carousel.querySelector('.personas-carousel__item.swiper-slide-active');
                return a && a.getAttribute('data-title-handle');
            };

            // Phase 1 — wait (bounded) until the slider is initialised and the target slide has a
            // swiper index. The on-init caller can fire while the slider is still settling, and the
            // event caller can fire before the (lazy) slider exists at all; both resolve here or
            // time out harmlessly (if the slider inits later, the on-init call re-runs this).
            let readyAttempts = 0;
            const READY_MAX = 30; // ~3s @ 100ms
            const whenReady = (cb) => {
                const swiper = window.Branch.personasCarousel.sliders[parent.getAttribute('id')];
                const slide = carousel.querySelector(`.personas-carousel__item[data-title-handle="${targetTitleHandle}"]:not(.swiper-slide-duplicate)`)
                    || carousel.querySelector(`.personas-carousel__item[data-title-handle="${targetTitleHandle}"]`);
                const idx = slide && slide.getAttribute('data-swiper-slide-index');
                const ready = swiper && typeof swiper.slideToLoop === 'function'
                    && carousel.querySelector('.personas-carousel__slider[data-initialized="true"]')
                    && idx != null;
                if (ready) { cb(swiper, parseInt(idx, 10)); return; }
                if (++readyAttempts < READY_MAX) setTimeout(() => whenReady(cb), 100);
            };

            whenReady((swiper, targetIdx) => {
                swiper.slideToLoop(targetIdx, 0);
                // Phase 2 — verify it landed and re-issue a few times if a late internal slideTo
                // (the slider's own init centering) bumped us off. Bounded, and stops the instant it
                // lands — so it corrects the init race but never fights a real user swipe (which
                // can't realistically happen within this ~0.6s window of the slider appearing).
                let verifyAttempts = 0;
                const VERIFY_MAX = 4;
                const verify = () => {
                    if (activeHandleOf() === targetTitleHandle) return; // landed
                    if (++verifyAttempts > VERIFY_MAX) return;
                    swiper.slideToLoop(targetIdx, 0);
                    setTimeout(verify, 150);
                };
                setTimeout(verify, 150);
            });
        });
    };

    // React to a client-side personalization change without a content swap.
    document.addEventListener('branch:personalization-updated', function(e){
        const handle = e && e.detail ? e.detail.handle : undefined;
        window.Branch.personasCarousel.goToPersonalizationDefaultSlide(handle);
    });

    function initPersonasCarouselSlider(personasCarouselSection, parent){
        if (personasCarouselSection.getAttribute('data-swiper-initialized') === 'true') {
            return;
        }
        personasCarouselSection.setAttribute('data-swiper-initialized', 'true');

        let slides = personasCarouselSection.querySelectorAll('.personas-carousel__item.swiper-slide')
        let cascadeIndex = parseInt(slides[0].getAttribute('data-cascade-order'));

        personasCarouselSection.querySelectorAll('.personas-carousel__item.swiper-slide').forEach((updatedSlide, index) => {
        updatedSlide.setAttribute('data-cascade-order', `${cascadeIndex}`);
        const width = window.innerWidth;

        if (
            (width < 900 && index < 2) ||
            (width < 1024 && index < 3) ||
            (width >= 1024 && index < 4)
        ) {
            cascadeIndex++;
        }
    });
        let parentId = parent.getAttribute('id');
        let enable_autoscroll = personasCarouselSection.getAttribute('data-enable-autoscroll') == 'true';
        let autoscroll_interval = 1000 * parseInt(personasCarouselSection.getAttribute('data-autoscroll-interval'));
        let autoplay = !enable_autoscroll ? false : {delay: autoscroll_interval, disableOnInteraction: true}
        let touchStartX = 0;
        let touchStartY = 0;
        let touchStartTime = 0;
        let isSwiping = false;

        const isMobile = window.innerWidth < 900;

        // Check AB test flag for mobile view
        const mobileTestElement = document.getElementById('personas-carousel-mobile-test');
        const useMobileTest = mobileTestElement && mobileTestElement.getAttribute('data-test-active') === 'true' && isMobile;

        // Create base config - use doorbusters-style if mobile test is active
        let swiperConfig = {};

        if (useMobileTest) {
            // Doorbusters-style configuration for mobile with same UX as control
            swiperConfig = {
                spaceBetween: 20,
                slidesPerView: 1.1,
                autoplay: autoplay,
                touchRatio: isMobile ? 0.3 : 1,
                loop: true,
                loopedSlides: 15,
                loopAdditionalSlides: 5,
                centeredSlides: true,
                slideToClickedSlide: true,
                grabCursor: true,
                threshold: isMobile ? 5 : 5,
                shortSwipes: true,
                longSwipesRatio: isMobile ? 0.15 : 0.2,
                resistanceRatio: 0,
                speed: isMobile ? 300 : 300,
                freeMode: false,
                watchSlidesProgress: true,
                updateOnWindowResize: true,
                touchStartPreventDefault: false,
                navigation: {
                    nextEl: `#${parentId} .personas-carousel__nav-right`,
                    prevEl: `#${parentId} .personas-carousel__nav-left`,
                },
                breakpoints: {
                    600: {
                        slidesPerView: 1.5,
                    },
                    900: {
                        slidesPerView: 2.5,
                    },
                    1024: {
                        slidesPerView: 3.5,
                    }
                }
            };
        } else {
            // Original personas-carousel configuration
            swiperConfig = {
                autoplay: autoplay,
                touchRatio: isMobile ? 0.3 : 1,
                loop: true,
                slideToClickedSlide: true,
                grabCursor: true,
                centeredSlides: true,
                slidesPerView: "auto",
                threshold: isMobile ? 5 : 5,
                shortSwipes: true,
                longSwipesRatio: isMobile ? 0.15 : 0.2,
                resistanceRatio: 0,
                speed: isMobile ? 800 : 300,
                freeMode: false,
                loopedSlides: 15,
                loopAdditionalSlides: 5,
                watchSlidesProgress: true,
                updateOnWindowResize: true,
                touchStartPreventDefault: false,
                navigation: {
                    nextEl: `#${parentId} .personas-carousel__nav-right`,
                    prevEl: `#${parentId} .personas-carousel__nav-left`,
                },
            };
        }

        // Add event handlers only for non-mobile-test configuration
        if (!useMobileTest) {
            swiperConfig.on = {
                init: function() {
                    setTimeout(() => {
                        this.slideTo(this.loopedSlides || 2, 0);
                        updateExtendedClasses(this);
                        // Set data-animated on all duplicate slides to prevent transparency
                        this.slides.forEach(slide => {
                            if (slide.classList.contains('swiper-slide-duplicate')) {
                                slide.setAttribute('data-animated', 'true');
                            }
                        });
                        setTimeout(() => {
                            generateSlideStyles(this);
                            setTimeout(() => {
                                document.querySelector(`#${parentId} .personas-carousel__slider`).setAttribute('data-initialized', true)
                                // Auto-center the personalization's nominated slide (if any) now that
                                // the slider is initialised and past its own initial slideTo.
                                window.Branch.personasCarousel.goToPersonalizationDefaultSlide(null, personasCarouselSection);
                            }, 1)
                        }, 250)
                    }, 250);
                },
                slideChange: function() {
                    updateExtendedClasses(this);
                },
                progress: function() {
                    updateExtendedClasses(this);
                },
                setTranslate: function() {
                    updateExtendedClasses(this);
                },
                touchStart: function(swiper, event) {
                    const touch = event.touches ? event.touches[0] : event;
                    touchStartX = touch.clientX;
                    touchStartY = touch.clientY;
                    touchStartTime = Date.now();
                    isSwiping = false;
                },
                touchMove: function() {
                    isSwiping = true;
                },
touchEnd: function(swiper, event) {
                    const touch = event.changedTouches ? event.changedTouches[0] : event;
                    const touchEndX = touch.clientX;
                    const touchEndY = touch.clientY;
                    const touchEndTime = Date.now();

                    const deltaX = Math.abs(touchEndX - touchStartX);
                    const deltaY = Math.abs(touchEndY - touchStartY);
                    const deltaTime = touchEndTime - touchStartTime;

                    if (!isSwiping && deltaX < 10 && deltaY < 10 && deltaTime < 300) {
                        const clickedSlide = event.target.closest('.personas-carousel__item');
                        if (clickedSlide) {
                            if (clickedSlide.classList.contains('swiper-slide-active')) {
                                const link = clickedSlide.querySelector('.personas-carousel__item-link');
                                if (link) {
                                    // Only navigate on left-click (button 0) or touch, allow right-click to show context menu
                                    if (!event.button || event.button === 0) {
                                        window.location.href = link.href;
                                    }
                                }
                            }
                        }
                    }
                }
            };
        }

        // Add data attribute to slider if mobile test is active
        if (useMobileTest) {
            personasCarouselSection.querySelector('.personas-carousel__slider').setAttribute('data-mobile-test', 'true');
        }

        // Create Swiper instance with the configured settings
        let swiperInstance = new Swiper(`#${parentId} .personas-carousel__slider`, swiperConfig);

        // Add click handlers to anchor links for proper right-click support
        const allLinks = personasCarouselSection.querySelectorAll('.personas-carousel__item-link');
        allLinks.forEach(link => {
            link.addEventListener('click', function(e) {
                const slide = this.closest('.personas-carousel__item');
                // Only allow navigation if the slide is active
                // Right-click (button 2) and middle-click (button 1) are handled by default browser behavior
                if (slide && !slide.classList.contains('swiper-slide-active')) {
                    e.preventDefault();
                }
            });

            // Ensure right-click context menu always works
            link.addEventListener('contextmenu', function(e) {
                // Allow default context menu behavior
                e.stopPropagation();
            });
        });

        // Set initialized attribute for mobile test (no init callback)
        if (useMobileTest) {
            setTimeout(() => {
                // Set data-animated on all duplicate slides to prevent transparency
                swiperInstance.slides.forEach(slide => {
                    if (slide.classList.contains('swiper-slide-duplicate')) {
                        slide.setAttribute('data-animated', 'true');
                    }
                });
                document.querySelector(`#${parentId} .personas-carousel__slider`).setAttribute('data-initialized', true);
            }, 100);
        }

        function updateExtendedClasses(swiper) {
            swiper.slides.forEach(slide => {
                slide.classList.remove('swiper-slide-prev-prev', 'swiper-slide-next-next', 'swiper-slide-prev-prev-prev', 'swiper-slide-next-next-next', 'swiper-slide-prev-prev-prev-prev', 'swiper-slide-next-next-next-next');
            });

            const visibleSlides = Array.from(swiper.slides).filter(slide => {
                return slide.style.display !== 'none';
            });

            const activeSlide = swiper.slides[swiper.activeIndex];
            const activeIndexInVisible = visibleSlides.indexOf(activeSlide);

            if (activeIndexInVisible === -1) return;

            const prevPrevIndex = activeIndexInVisible - 2;
            const nextNextIndex = activeIndexInVisible + 2;
            const prevPrevPrevIndex = activeIndexInVisible - 3;
            const nextNextNextIndex = activeIndexInVisible + 3;
            const prevPrevPrevPrevIndex = activeIndexInVisible - 4;
            const nextNextNextNextIndex = activeIndexInVisible + 4;
            const totalVisibleSlides = visibleSlides.length;

            const getLoopedIndex = (index) => {
                if (index < 0) {
                    return totalVisibleSlides + index;
                } else if (index >= totalVisibleSlides) {
                    return index - totalVisibleSlides;
                }
                return index;
            };

            const loopedPrevPrevIndex = getLoopedIndex(prevPrevIndex);
            if (visibleSlides[loopedPrevPrevIndex]) {
                visibleSlides[loopedPrevPrevIndex].classList.add('swiper-slide-prev-prev');
            }

            const loopedNextNextIndex = getLoopedIndex(nextNextIndex);
            if (visibleSlides[loopedNextNextIndex]) {
                visibleSlides[loopedNextNextIndex].classList.add('swiper-slide-next-next');
            }

            const loopedPrevPrevPrevIndex = getLoopedIndex(prevPrevPrevIndex);
            if (visibleSlides[loopedPrevPrevPrevIndex]) {
                visibleSlides[loopedPrevPrevPrevIndex].classList.add('swiper-slide-prev-prev-prev');
            }

            const loopedNextNextNextIndex = getLoopedIndex(nextNextNextIndex);
            if (visibleSlides[loopedNextNextNextIndex]) {
                visibleSlides[loopedNextNextNextIndex].classList.add('swiper-slide-next-next-next');
            }

            const loopedPrevPrevPrevPrevIndex = getLoopedIndex(prevPrevPrevPrevIndex);
            if (visibleSlides[loopedPrevPrevPrevPrevIndex]) {
                visibleSlides[loopedPrevPrevPrevPrevIndex].classList.add('swiper-slide-prev-prev-prev-prev');
            }

            const loopedNextNextNextNextIndex = getLoopedIndex(nextNextNextNextIndex);
            if (visibleSlides[loopedNextNextNextNextIndex]) {
                visibleSlides[loopedNextNextNextNextIndex].classList.add('swiper-slide-next-next-next-next');
            }
        }

        function generateSlideStyles(swiper) {
            const existingStyle = document.getElementById(`${parentId}-slide-styles`);
            if (existingStyle) {
                existingStyle.remove();
            }

            const swiperContainer = swiper.el;
            const activeSlide = swiperContainer.querySelector('.swiper-slide-active');

            swiperContainer.querySelectorAll('.swiper-slide').forEach((slide) => {
                slide.style.transition = 'transform 0s linear'
            });

            if (!activeSlide) return;

            if (activeSlide.style.display === 'none') return;

            const swiperRect = swiperContainer.getBoundingClientRect();
            const activeRect = activeSlide.getBoundingClientRect();
            const slideWidth = activeRect.width;
            const slideHeight = activeRect.height;
            const swiperWidth = swiperRect.width;

            const activeLeftEdge = activeRect.left - swiperRect.left;
            let prevPrevLeftEdge = activeLeftEdge - slideWidth - slideWidth;
            let nextNextRightEdge = activeLeftEdge + slideWidth + slideWidth + slideWidth;

            const prevPrevTranslate = -prevPrevLeftEdge;
            const nextNextTranslate = swiperWidth - nextNextRightEdge;

            const prevTranslate = prevPrevTranslate / 2;
            const nextTranslate = nextNextTranslate / 2;

            const prevPrevPrevTranslate = prevPrevTranslate * 1.5;
            const nextNextNextTranslate = nextNextTranslate * 1.5;
            const prevPrevPrevPrevTranslate = prevPrevTranslate * 2;
            const nextNextNextNextTranslate = nextNextTranslate * 2;

            const isMobileStyles = window.innerWidth < 900;

            // On mobile, reduce scale differences for smoother drag feel
            const styleElement = document.createElement('style');
            styleElement.id = `${parentId}-slide-styles`;
            let ninetyScale = isMobileStyles ? ((slideHeight - 20) / slideHeight) : ((slideHeight - 44) / slideHeight);
            let ninetyFiveScale = isMobileStyles ? ((slideHeight - 10) / slideHeight) : ((slideHeight - 22) / slideHeight);
            let hundredFiveScale = isMobileStyles ? ((slideHeight + 10) / slideHeight) : ((slideHeight + 22) / slideHeight);
            let hundredTenScale = isMobileStyles ? ((slideHeight + 20) / slideHeight) : ((slideHeight + 44) / slideHeight);

            styleElement.innerHTML = `
                #${parentId} .swiper-slide-prev {
                    transform: translateX(${prevTranslate}px) scale(${hundredFiveScale}) !important;
                }

                #${parentId} .swiper-slide-prev-prev {
                    transform: translateX(${prevPrevTranslate}px) scale(1) !important;
                }

                #${parentId} .swiper-slide-prev-prev-prev {
                    transform: translateX(${prevPrevPrevTranslate}px) scale(${ninetyFiveScale}) !important;
                }

                #${parentId} .swiper-slide-prev-prev-prev-prev {
                    transform: translateX(${prevPrevPrevPrevTranslate}px) scale(${ninetyScale}) !important;
                }

                #${parentId} .swiper-slide-next {
                    transform: translateX(${nextTranslate}px) scale(${hundredFiveScale}) !important ;
                }

                #${parentId} .swiper-slide-next-next {
                    transform: translateX(${nextNextTranslate}px) scale(1) !important;
                }

                #${parentId} .swiper-slide-next-next-next {
                    transform: translateX(${nextNextNextTranslate}px) scale(${ninetyFiveScale}) !important;
                }

                #${parentId} .swiper-slide-next-next-next-next {
                    transform: translateX(${nextNextNextNextTranslate}px) scale(${ninetyScale}) !important;
                }

                #${parentId} .swiper-slide-active {
                    transform: scale(${hundredTenScale}) !important;
                }

                #${parentId} .swiper-slide:not(.swiper-slide-active):not(.swiper-slide-next):not(.swiper-slide-next-next):not(.swiper-slide-prev-prev):not(.swiper-slide-prev):not(.swiper-slide-prev-prev-prev):not(.swiper-slide-next-next-next):not(.swiper-slide-prev-prev-prev-prev):not(.swiper-slide-next-next-next-next) {
                    transform: scale(1) !important;
                }
            `;

            personasCarouselSection.insertAdjacentElement('afterend', styleElement);

            const isMobileTransitionEnd = window.innerWidth < 900;
            swiperContainer.querySelectorAll('.swiper-slide').forEach((slide) => {
                slide.style.transition = isMobileTransitionEnd ? 'transform 800ms cubic-bezier(0.25, 0.1, 0.25, 1)' : ''
            });
        }

        let resizeTimeout;
        window.addEventListener('resize', function() {
            clearTimeout(resizeTimeout);
            resizeTimeout = setTimeout(() => {
                // Only apply custom slide styles if mobile test is NOT active
                if (!useMobileTest) {
                    generateSlideStyles(swiperInstance);
                }
            }, 250);
        });

        const categoryButtons = personasCarouselSection.querySelectorAll('.personas-carousel__button');
        const defaultButton = Array.from(categoryButtons).find(btn =>
            btn.getAttribute('data-category') === 'all-categories'
        );
        if (defaultButton) {
            defaultButton.classList.add('active');
        }

        const hiddenSlidesContainer = document.createElement('div');
        hiddenSlidesContainer.style.display = 'none';
        hiddenSlidesContainer.classList.add('personas-carousel__hidden-slides');
        personasCarouselSection.appendChild(hiddenSlidesContainer);

        categoryButtons.forEach(button => {
            button.addEventListener('click', function() {
                const selectedCategory = this.getAttribute('data-category');

                if (this.classList.contains('active')) {
                    if (selectedCategory !== 'all-categories' && defaultButton) {
                        categoryButtons.forEach(btn => btn.classList.remove('active'));
                        defaultButton.classList.add('active');
                        defaultButton.click();
                    }
                    return;
                }

                categoryButtons.forEach(btn => btn.classList.remove('active'));
                this.classList.add('active');

                const swiperWrapper = personasCarouselSection.querySelector('.swiper-wrapper');
                const swiperElement = personasCarouselSection.querySelector('.swiper');

                const loadingOverlay = document.createElement('div');
                loadingOverlay.classList.add('personas-carousel__loading-overlay');
                loadingOverlay.style.cssText = `
                    position: absolute;
                    top: 0;
                    left: 0;
                    width: 100%;
                    height: 100%;
                    ${swiperElement.closest('.personas-carousel').getAttribute('style')}
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    z-index: 1000;
                    opacity: 1;
                    transition: opacity 0.25s ease-out;
                    pointer-events: none;
                `;

                const swiperClone = swiperElement.cloneNode(true);
                swiperClone.classList.remove('swiper-initialized', 'swiper-horizontal', 'swiper-backface-hidden');
                swiperClone.removeAttribute('data-swiper-initialized');
                swiperClone.style.cursor = 'default';
                swiperClone.setAttribute('data-overlay', true);

                const navElements = swiperClone.querySelectorAll('.swiper-button-next, .swiper-button-prev, .swiper-pagination, .swiper-scrollbar');
                navElements.forEach(el => el.remove());

                const existingStyle = document.getElementById(`${parentId}-slide-styles`);
                if (existingStyle) {
                    const styleClone = existingStyle.cloneNode(true);
                    styleClone.id = `${parentId}-slide-styles-overlay`;

                    let styleContent = styleClone.innerHTML;
                    styleContent = styleContent.replace(/#shopify-section-[^\s]+/g, (match) => {
                        return `.personas-carousel__loading-overlay ${match}`;
                    });
                    styleClone.innerHTML = styleContent;

                    loadingOverlay.appendChild(styleClone);
                }

                const loadingIconHTML = `
                    <div class="loading-icon-container">
                        <svg class="progress-ring" width="200" height="200" viewBox="0 0 220 220">
                            <circle class="progress-ring-base" r="100" cx="110" cy="110" />
                            <circle class="progress-ring-circle" r="100" cx="110" cy="110" />
                        </svg>
                        <svg class="progress-chair" xmlns="http://www.w3.org/2000/svg" width="80" height="119" viewBox="0 0 80 119" fill="none">
                            <path d="M33.3042 95.4188C23.6442 99.3856 13.9842 103.394 4.55479 107.34C3.92493 107.71 3.38179 108.211 2.96224 108.809C2.57042 109.322 2.22673 109.87 1.9355 110.446C1.46342 111.142 1.10282 111.906 0.866804 112.713C0.741013 113.632 0.741013 114.564 0.866804 115.484C0.915287 116.275 1.25063 117.021 1.80977 117.582C2.37434 118.136 3.11701 118.471 3.90521 118.527C4.39763 118.601 4.89512 118.636 5.39301 118.632C8.17994 118.632 9.18575 117.373 9.58388 116.176C9.66809 115.81 9.66809 115.43 9.58388 115.064C9.58388 113.993 9.43721 112.965 9.33244 111.706L9.20671 110.341C17.3789 107.865 25.8235 105.283 34.3519 102.807C35.2643 102.642 36.1912 102.572 37.1179 102.597V109.817C37.1179 109.817 37.1179 109.964 36.9922 110.027C36.8759 110.192 36.7907 110.377 36.7407 110.572C36.3214 111.455 36.0118 112.385 35.8187 113.343C35.5287 114.795 35.8223 116.304 36.6359 117.54C37.5578 118.527 39.0457 118.527 41.3088 118.527C42.0779 118.53 42.8223 118.254 43.4042 117.75C43.9795 117.243 44.3456 116.54 44.4309 115.777V115.043C44.6761 114.175 44.6786 113.256 44.4385 112.386C44.1983 111.516 43.7246 110.729 43.0689 110.111C42.9579 109.967 42.9054 109.787 42.9222 109.607V102.492C43.8271 102.47 44.7322 102.533 45.6253 102.681C51.5973 104.36 56.8987 105.892 61.823 107.424C64.1489 108.138 66.4748 108.956 68.7379 109.754L71.2315 110.635C70.8321 111.5 70.6044 112.433 70.5609 113.385C70.4923 114.486 70.6639 115.589 71.0638 116.617C71.3153 117.394 72.2792 117.813 73.1592 118.212L73.4946 118.359H73.5993C74.1479 118.443 74.7061 118.443 75.2547 118.359C76.9729 118.359 78.775 118.065 79.1941 115.945C79.8437 112.524 79.1941 110.341 77.5388 109.649C77.419 109.586 77.3123 109.5 77.2244 109.397C77.2244 107.739 76.1557 107.298 75.129 106.836L61.3621 101.149L46.694 95.062C46.3009 94.9541 45.9595 94.7082 45.7325 94.369C45.5055 94.0299 45.408 93.6203 45.4577 93.215C45.418 92.7752 45.418 92.3326 45.4577 91.8927C45.6823 91.223 45.6832 90.4983 45.4601 89.8281C45.2371 89.1579 44.8022 88.5786 44.2213 88.1778V82.3431H44.5986C46.2121 82.3431 48.0141 82.3431 48.999 80.601C49.7114 79.0864 50.2933 77.5136 50.7382 75.8997L53.4203 75.312C55.1805 74.9552 56.9825 74.5565 58.7636 74.0947C61.4758 73.6521 64.0057 72.4435 66.0558 70.6107C66.459 70.1685 66.952 69.8178 67.5017 69.5822C68.0461 69.3301 68.6413 69.208 69.2408 69.2254C70.0001 69.2679 70.7592 69.1388 71.4619 68.8477C72.174 68.5709 72.8123 68.1326 73.3269 67.5674C73.8421 67.0074 74.2284 66.3412 74.4585 65.6155C74.6935 64.9061 74.7651 64.1527 74.668 63.4117C74.668 61.3129 74.5214 59.2141 74.4585 57.2412L74.207 50.5878V44.9H75.1709C78.4188 44.9 79.0266 44.2704 79.0266 40.9332C79.0266 39.1282 78.4398 38.1628 76.1139 38.1628C75.1081 38.1628 74.0184 38.1628 73.0755 38.1628H70.058C69.4607 38.1003 68.8604 38.2488 68.3607 38.5825C67.8742 38.9079 67.5238 39.4008 67.376 39.9678C67.1242 40.7526 67.1242 41.5966 67.376 42.3814C67.5917 43.2048 68.0608 43.9392 68.7169 44.4802C68.8991 44.5959 69.0502 44.7544 69.157 44.942C69.2677 45.0976 69.3395 45.2775 69.3665 45.4667C69.5132 48.8038 69.6181 52.141 69.7228 55.4571C69.7228 58.0597 69.8066 60.6622 69.9743 63.2648C69.9964 63.4197 69.9874 63.5775 69.9478 63.7288C69.9082 63.8802 69.8389 64.0221 69.7438 64.1462C69.566 64.2497 69.3625 64.3006 69.157 64.2932C69.2362 63.2763 69.1369 62.2534 68.8636 61.2709C68.5443 60.1482 67.9949 59.1046 67.2502 58.2066C65.9095 56.5542 63.992 55.4739 61.8859 55.1843C62.1374 54.7855 62.3888 54.4077 62.6193 54.0089C63.3108 52.9385 63.9603 51.9101 64.547 50.8187C66.2886 46.6484 66.7624 42.056 65.9091 37.6171L65.511 33.4194C65.1129 29.0959 64.6728 24.6253 64.3585 20.2178C64.1909 18.119 64.107 16.0202 64.0442 13.9213C63.9813 11.8225 63.8974 10.0805 63.7508 8.21251C63.7974 6.52235 63.1978 4.87818 62.0744 3.61607C60.9978 2.37687 59.5086 1.57141 57.8836 1.34937C54.9393 0.825025 51.9648 0.488512 48.978 0.341908C41.0391 -0.225176 33.0655 -0.0776851 25.1529 0.782644C19.0343 1.47526 16.5198 4.26675 16.5198 10.4163C16.5198 11.1929 16.5198 11.9904 16.5198 12.767C16.6036 14.319 16.6036 15.8744 16.5198 17.4264C16.0797 22.9043 15.5558 28.4872 15.0529 33.9021C14.8434 36.001 14.6548 38.2887 14.4453 40.4715C14.1251 43.0564 14.3463 45.6797 15.0949 48.1742C15.8326 50.6607 17.0737 52.9684 18.7409 54.9534L18.8876 55.1423C13.6281 56.2967 11.1345 59.34 11.4279 64.2512C11.1898 64.2959 10.9435 64.251 10.7363 64.1253C10.5726 63.8935 10.4982 63.6102 10.5268 63.3277C10.7154 57.3881 10.8831 51.4484 11.0297 45.6976V45.5507C11.0297 44.8371 11.0297 44.6062 11.7841 44.3333C13.1461 43.8086 13.3975 41.7098 12.9575 39.9888C12.7813 39.4127 12.411 38.9157 11.9098 38.5825C11.4392 38.2744 10.8758 38.1408 10.3172 38.2048C8.53611 38.0788 6.75508 38.2048 5.03682 38.0788C4.41015 38.0001 3.77374 38.082 3.18733 38.317C2.60092 38.5519 2.08364 38.9322 1.68405 39.4221C1.35629 39.9513 1.16041 40.5518 1.113 41.1728C1.06559 41.7938 1.16802 42.4171 1.41164 42.9901C1.54446 43.5191 1.85537 43.9861 2.29181 44.3124C2.72561 44.6421 3.2559 44.8192 3.80046 44.8161H6.29403C6.29403 47.2927 6.16825 49.7273 6.10539 52.183C6.10539 55.8559 5.93777 59.6758 5.72822 63.5166C5.58918 64.6102 5.80039 65.7197 6.33138 66.6854C6.86236 67.651 7.68578 68.4228 8.68286 68.8896C9.34427 69.1827 10.0555 69.3466 10.7783 69.3724H12.4966C12.736 69.3473 12.9759 69.4149 13.1671 69.5613C15.4572 72.0201 18.5042 73.6385 21.8211 74.1577C23.9166 74.6614 26.0121 75.1441 27.8351 75.5429L29.4276 75.8997C29.9299 77.5652 30.5678 79.1867 31.3345 80.748C31.7978 81.3661 32.4225 81.8441 33.1398 82.1293C33.8571 82.4145 34.6392 82.4958 35.3996 82.3641H36.112C36.112 82.6999 36.112 83.0147 36.112 83.3296C36.112 84.2111 36.112 85.0086 36.112 85.8272C36.112 86.1 36.112 86.3729 36.112 86.6667C36.112 87.7581 36.1121 88.4507 35.2739 88.9334C34.75 89.1433 34.75 89.8569 34.75 90.2977C34.6663 91.3174 34.6663 92.3422 34.75 93.362C34.6872 94.6003 34.3938 94.9781 33.3042 95.4188ZM7.59319 45.8865C7.67879 45.545 7.78378 45.2086 7.90756 44.879H8.68286V51.7212C8.68286 53.3583 8.61994 54.9954 8.49421 56.6325C8.49421 58.8572 8.30569 61.1659 8.30569 63.4537C8.30569 64.9438 8.6199 66.5179 10.9458 66.7068C11.177 66.7687 11.4016 66.853 11.6164 66.9587C10.3671 67.1304 9.10092 66.7983 8.09607 66.0352C7.73193 65.6364 7.45751 65.164 7.29123 64.6498C7.12495 64.1357 7.07074 63.5918 7.13226 63.0549C7.25798 59.193 7.3627 55.3312 7.46747 51.4694L7.59319 45.8865ZM9.54193 42.6123C8.66185 42.6123 7.78176 42.6123 6.92264 42.6123C6.06351 42.6123 5.18343 42.6123 4.30334 42.6123C4.03812 42.6591 3.76492 42.6147 3.52805 42.4864C3.36094 42.1941 3.29473 41.8547 3.33953 41.5209C3.33879 41.3946 3.36445 41.2696 3.41499 41.1539C3.46552 41.0383 3.5397 40.9345 3.63279 40.8493C4.02327 40.5146 4.52301 40.3353 5.03682 40.3456H8.0123C8.78761 40.2165 9.58381 40.3493 10.2754 40.7233C10.3729 40.8347 10.4472 40.9645 10.494 41.1051C10.5408 41.2456 10.5591 41.3942 10.5478 41.5419C10.5478 42.4864 10.4011 42.6123 9.54193 42.6123ZM32.1936 76.1936C37.3459 77.0752 42.6102 77.0752 47.7626 76.1936C47.8907 76.6694 47.9196 77.1665 47.8475 77.6539C47.7754 78.1414 47.6039 78.6088 47.3436 79.0269C46.9565 79.389 46.4957 79.6628 45.9929 79.8294C45.4901 79.9961 44.9572 80.0517 44.4309 79.9924H35.4834C34.9799 80.047 34.4707 79.9928 33.99 79.8335C33.5092 79.6742 33.068 79.4135 32.6964 79.0689C32.4337 78.6635 32.254 78.2098 32.1677 77.7342C32.0814 77.2586 32.0902 76.7706 32.1936 76.2985V76.1936ZM41.7069 82.3431V87.926H38.2494V82.3431H41.7069ZM43.0061 90.5285V94.3694H37.2017C37.0559 94.2977 36.938 94.1796 36.8665 94.0336V90.5285H43.0061ZM72.824 113.595C73.1593 114.665 73.6203 114.917 74.9195 114.707C76.2186 114.497 76.6796 114.161 76.8892 113.511C77.0733 114.198 77.0733 114.922 76.8892 115.61C75.6623 115.911 74.3893 115.975 73.1384 115.798C72.8453 115.103 72.7369 114.344 72.824 113.595ZM74.5633 109.691C74.4045 109.473 74.2053 109.288 73.9765 109.145C73.7734 109.01 73.5454 108.917 73.3059 108.872L69.1151 107.529C61.4248 105.073 53.4622 102.555 45.5415 100.141C44.2403 99.9203 42.9041 100.043 41.665 100.498C41.0154 100.645 40.68 101.82 40.68 102.408V112.524H39.5066V105.241C39.5066 104.78 39.5066 104.339 39.5066 103.856C39.4928 103.597 39.4928 103.338 39.5066 103.08C39.5066 102.051 39.5067 100.981 38.8152 100.834C37.4697 100.2 35.9564 100.016 34.4986 100.309C29.9306 101.673 25.3206 103.142 20.8573 104.507C16.394 105.871 12.0774 107.298 7.67696 108.704C6.97942 108.875 6.33735 109.222 5.81212 109.712C5.88381 109.61 5.96072 109.512 6.04259 109.418C6.30226 109.091 6.6316 108.825 7.00654 108.641L11.4069 106.815L34.7919 97.1818C35.5074 96.9061 36.2673 96.7638 37.034 96.762H43.8651C44.2298 96.7598 44.5919 96.8238 44.9338 96.9509C54.929 101.149 64.8195 105.157 74.2699 109.145C74.4497 109.245 74.6011 109.39 74.71 109.565C74.8162 109.738 74.8873 109.931 74.9195 110.132V110.362C74.8215 110.12 74.6873 109.893 74.5213 109.691H74.5633ZM7.2998 113.49V113.826C7.36548 114.442 7.29397 115.066 7.09031 115.651C6.57547 115.941 6.00303 116.113 5.41399 116.155C4.80826 116.231 4.19313 116.174 3.61182 115.987C3.21368 115.777 2.96234 114.791 3.06711 113.616C3.40238 114.644 3.94719 114.896 5.16254 114.833C6.3779 114.77 7.15312 114.182 7.2998 113.49ZM38.0399 114.938C38.7204 115.132 39.4289 115.21 40.1353 115.169C40.8527 115.134 41.56 114.985 42.2308 114.728C42.105 115.148 41.9374 115.798 41.7907 115.861C40.7324 116.187 39.601 116.187 38.5428 115.861C38.3038 115.598 38.1314 115.282 38.0399 114.938ZM58.9942 54.7015C58.7245 54.9582 58.3788 55.1202 58.0093 55.1633L55.1176 55.6041C52.2678 56.0238 49.3133 56.4856 46.4216 56.7794C44.642 56.8844 42.8577 56.8844 41.0782 56.7794C35.8 57.0982 30.5039 56.6313 25.3624 55.3942C24.9554 55.2675 24.5314 55.2038 24.1052 55.2053H23.9585C23.1128 55.2982 22.2589 55.1311 21.5103 54.7262C20.7618 54.3213 20.1539 53.6978 19.7677 52.9385C17.4842 49.9361 16.3538 46.2118 16.5826 42.4444C16.855 38.6455 17.2112 34.7837 17.5675 31.0478C17.8399 28.0045 18.1332 24.9612 18.3637 21.9389C18.5104 20.0499 18.5733 18.119 18.6362 16.23C18.6362 14.9917 18.6362 13.7324 18.7829 12.4731C18.7829 11.9064 18.7828 11.3398 18.8876 10.7731C18.9924 10.2064 19.0133 9.17801 19.0133 8.38045C19.0199 7.23692 19.4538 6.13728 20.2295 5.29818C21.0052 4.45909 22.0664 3.94138 23.2042 3.84698C27.0421 3.20086 30.9219 2.83605 34.8128 2.75555C40.1772 2.75555 45.6253 2.9235 50.9058 3.13338L54.2585 3.25931C55.5974 3.36816 56.9154 3.65762 58.177 4.11984C59.055 4.39382 59.8295 4.92799 60.3981 5.65194C60.9735 6.3785 61.3102 7.26561 61.3621 8.1915C61.6085 9.6187 61.7067 11.0677 61.6553 12.5151C62.0116 17.7412 62.3678 23.0093 62.6821 28.2563C62.7868 29.8515 62.8917 31.4465 63.0174 33.0626C63.2898 37.0924 63.6041 41.29 63.6041 45.3827C63.5132 47.1516 63.0718 48.8847 62.3055 50.481C61.5393 52.0773 60.4634 53.5049 59.1408 54.6806L58.9942 54.7015ZM16.9598 58.3745C18.5779 57.8958 20.222 57.5104 21.8841 57.2201L23.4766 57.514C25.7397 57.9127 27.877 58.3115 30.1191 58.6054C38.0168 59.7436 46.0494 59.545 53.8814 58.0177C56.3385 57.5316 58.8587 57.4536 61.3411 57.7868C62.7562 57.8137 64.1067 58.3848 65.1129 59.3819C66.1137 60.3964 66.6908 61.755 66.7264 63.1808C66.9401 64.6274 66.6672 66.1042 65.951 67.3785C65.2304 68.6412 64.1201 69.6355 62.787 70.2119C59.2758 71.4717 55.6846 72.4954 52.0374 73.2762C41.147 75.6003 29.8249 74.8298 19.3485 71.0514C17.5632 70.7039 15.9757 69.6914 14.9062 68.218C13.8349 66.7403 13.37 64.9075 13.6071 63.0968C13.6046 62.0604 13.9267 61.0492 14.5282 60.2058C15.1296 59.3624 15.9802 58.7293 16.9598 58.3955V58.3745ZM71.8811 42.8642C71.0424 42.8992 70.2232 42.6056 69.5971 42.0456C69.5434 41.9232 69.5156 41.791 69.5156 41.6573C69.5156 41.5236 69.5434 41.3914 69.5971 41.269C69.6343 41.1456 69.7072 41.0361 69.8066 40.9542C69.8851 40.8804 69.9778 40.8232 70.079 40.7863C72.0857 40.6119 74.1 40.5419 76.1139 40.5765C76.5539 40.5765 76.7006 41.0172 76.7635 41.269C76.84 41.5303 76.8391 41.8082 76.761 42.069C76.6829 42.3298 76.5309 42.5623 76.3234 42.7383C75.9049 42.8755 75.4627 42.9254 75.0242 42.8851H74.4166C73.9765 42.8851 73.5365 42.8851 73.0755 42.8851L71.8811 42.8642ZM71.8811 63.1598C71.8811 59.235 71.6506 55.8979 71.5039 52.3089L71.3362 47.7335V45.005H71.4829C71.6296 45.1309 71.8182 45.2359 71.9858 45.3618L72.4678 45.6556C72.5726 48.1322 72.6354 50.6088 72.6983 53.0855C72.6983 54.7855 72.6983 56.4856 72.845 58.2276C72.9917 59.9696 72.9917 61.5227 72.9917 63.1598C73.0496 63.6709 72.9932 64.1884 72.8265 64.6749C72.6597 65.1614 72.3869 65.6046 72.0278 65.9722C71.2851 66.5219 70.3718 66.7897 69.4504 66.7278C71.3782 66.2661 71.7553 65.6154 71.7553 63.1178L71.8811 63.1598Z" fill="#74857A"/>
                        </svg>
                    </div>
                `;
                loadingOverlay.insertAdjacentHTML('afterbegin', loadingIconHTML);
                loadingOverlay.appendChild(swiperClone);

                swiperElement.parentElement.style.position = 'relative';
                swiperElement.parentElement.appendChild(loadingOverlay);

                setTimeout(() => {
                    swiperInstance.destroy(true, true);
                    const hiddenSlides = hiddenSlidesContainer.querySelectorAll('.personas-carousel__item');
                    hiddenSlides.forEach(slide => {
                        swiperWrapper.appendChild(slide);
                    });

                    const allSlides = swiperWrapper.querySelectorAll('.personas-carousel__item');
                    allSlides.forEach(slide => {
                        const slideCategories = slide.getAttribute('data-categories');
                        slide.classList.remove('swiper-slide-prev-prev', 'swiper-slide-next-next', 'swiper-slide-prev-prev-prev', 'swiper-slide-next-next-next', 'swiper-slide-prev-prev-prev-prev', 'swiper-slide-next-next-next-next');

                        if (slideCategories && slideCategories.includes(selectedCategory)) {
                            slide.style.display = '';
                        } else {
                            hiddenSlidesContainer.appendChild(slide);
                        }
                    });

                    // Reorder slides by data-index-in-order before recreating swiper
                    reorderPersonasCarouselItems(personasCarouselSection);

                    setTimeout(() => {
                        const isMobileFilter = window.innerWidth < 900;

                        // Re-check mobile test flag for filter recreation
                        const mobileTestElementFilter = document.getElementById('personas-carousel-mobile-test');
                        const useMobileTestFilter = mobileTestElementFilter && mobileTestElementFilter.getAttribute('data-test-active') === 'true' && isMobileFilter;

                        // Build config based on mobile test status
                        let newSwiperConfig = {};

                        if (useMobileTestFilter) {
                            // Doorbusters-style configuration
                            newSwiperConfig = {
                                spaceBetween: 20,
                                slidesPerView: 1.1,
                                autoplay: autoplay,
                                touchRatio: isMobileFilter ? 0.3 : 1,
                                loop: true,
                                loopedSlides: 15,
                                loopAdditionalSlides: 5,
                                centeredSlides: true,
                                slideToClickedSlide: true,
                                grabCursor: true,
                                threshold: isMobileFilter ? 5 : 5,
                                shortSwipes: true,
                                longSwipesRatio: isMobileFilter ? 0.15 : 0.2,
                                resistanceRatio: 0,
                                speed: isMobileFilter ? 300 : 300,
                                freeMode: false,
                                watchSlidesProgress: true,
                                updateOnWindowResize: true,
                                touchStartPreventDefault: false,
                                navigation: {
                                    nextEl: `#${parentId} .personas-carousel__nav-right`,
                                    prevEl: `#${parentId} .personas-carousel__nav-left`,
                                },
                                breakpoints: {
                                    600: {
                                        slidesPerView: 1.5,
                                    },
                                    900: {
                                        slidesPerView: 2.5,
                                    },
                                    1024: {
                                        slidesPerView: 3.5,
                                    }
                                }
                            };
                        } else {
                            // Original configuration with callbacks
                            newSwiperConfig = {
                                autoplay: autoplay,
                                touchRatio: isMobileFilter ? 0.3 : 1,
                                loop: true,
                                slideToClickedSlide: true,
                                grabCursor: true,
                                centeredSlides: true,
                                slidesPerView: "auto",
                                threshold: isMobileFilter ? 5 : 5,
                                shortSwipes: true,
                                longSwipesRatio: isMobileFilter ? 0.15 : 0.2,
                                resistanceRatio: 0,
                                speed: isMobileFilter ? 800 : 300,
                                freeMode: false,
                                loopedSlides: 15,
                                loopAdditionalSlides: 5,
                                watchSlidesProgress: true,
                                updateOnWindowResize: true,
                                touchStartPreventDefault: false,
                                navigation: {
                                    nextEl: `#${parentId} .personas-carousel__nav-right`,
                                    prevEl: `#${parentId} .personas-carousel__nav-left`,
                                },
                                on: {
                                    init: function() {
                                        setTimeout(() => {
                                            this.slideTo(2, 0);

                                            updateExtendedClasses(this);
                                            // Set data-animated on all duplicate slides to prevent transparency
                                            this.slides.forEach(slide => {
                                                if (slide.classList.contains('swiper-slide-duplicate')) {
                                                    slide.setAttribute('data-animated', 'true');
                                                }
                                            });
                                            setTimeout(() => {
                                                generateSlideStyles(this);
                                                setTimeout(() => {
                                                    loadingOverlay.remove();
                                                }, 500);
                                            }, 250);
                                        }, 50);
                                    },
                                    slideChange: function() {
                                        updateExtendedClasses(this);
                                    },
                                    progress: function() {
                                        updateExtendedClasses(this);
                                    },
                                    setTranslate: function() {
                                        updateExtendedClasses(this);
                                    },
                                    touchStart: function(swiper, event) {
                                        const touch = event.touches ? event.touches[0] : event;
                                        touchStartX = touch.clientX;
                                        touchStartY = touch.clientY;
                                        touchStartTime = Date.now();
                                        isSwiping = false;
                                    },
                                    touchMove: function() {
                                        isSwiping = true;
                                    },
                                    touchEnd: function(swiper, event) {
                                        const touch = event.changedTouches ? event.changedTouches[0] : event;
                                        const touchEndX = touch.clientX;
                                        const touchEndY = touch.clientY;
                                        const touchEndTime = Date.now();

                                        const deltaX = Math.abs(touchEndX - touchStartX);
                                        const deltaY = Math.abs(touchEndY - touchStartY);
                                        const deltaTime = touchEndTime - touchStartTime;

                                        if (!isSwiping && deltaX < 10 && deltaY < 10 && deltaTime < 300) {
                                            const clickedSlide = event.target.closest('.personas-carousel__item');
                                            if (clickedSlide) {
                                                if (clickedSlide.classList.contains('swiper-slide-active')) {
                                                    const link = clickedSlide.querySelector('.personas-carousel__item-link');
                                                    if (link) {
                                                        // Only navigate on left-click (button 0) or touch, allow right-click to show context menu
                                                        if (!event.button || event.button === 0) {
                                                            window.location.href = link.href;
                                                        }
                                                    }
                                                }
                                            }
                                        }
                                    }
                                }
                            };
                        }

                        const newSwiperInstance = new Swiper(`#${parentId} .personas-carousel__slider:not([data-overlay="true"])`, newSwiperConfig);

                        // Handle mobile test initialization
                        if (useMobileTestFilter) {
                            setTimeout(() => {
                                // Set data-animated on all duplicate slides to prevent transparency
                                newSwiperInstance.slides.forEach(slide => {
                                    if (slide.classList.contains('swiper-slide-duplicate')) {
                                        slide.setAttribute('data-animated', 'true');
                                    }
                                });
                                loadingOverlay.remove();
                            }, 500);
                        }

                        window.Branch.personasCarousel.sliders[`${parentId}`] = newSwiperInstance;
                        swiperInstance = newSwiperInstance;
                    }, 250);
                }, 250);
            });
        });

        window.Branch.personasCarousel.sliders[`${parentId}`] = swiperInstance;
    }

function actionsOnVisible(personasCarouselSection, parent){
        personasCarouselSection.setAttribute('data-interacted', true);
        if (!personasCarouselSection.getAttribute('data-srcset-initialized')) {
            window.Branch.nav.handleUpdateSrcSet(null, '.personas-carousel__image', '.personas-carousel__image-container', 900);
            personasCarouselSection.setAttribute('data-srcset-initialized', 'true');
        }

        reorderPersonasCarouselItems(personasCarouselSection);
        // Wait for browser to paint the reordered DOM before initializing Swiper
        requestAnimationFrame(() => {
            initPersonasCarouselSlider(personasCarouselSection, parent);
        });
    }

function reorderPersonasCarouselItems(personasCarouselSection){
    const container = personasCarouselSection.querySelector('.personas-carousel__slider-inner');
    if(!container) return;

    const items = Array.from(container.querySelectorAll('.personas-carousel__item'));

    items.sort((a, b) => {
        const orderA = parseInt(a.getAttribute('data-index-in-order')) || 0;
        const orderB = parseInt(b.getAttribute('data-index-in-order')) || 0;
        return orderA - orderB;
    });

    items.forEach(item => item.remove());

    items.forEach((item, index) => {
        item.setAttribute('data-index', index);
        container.appendChild(item);
    });
}    

function initImageCarouselCallback(personasCarouselSection, parent, type){
        let fromLoad = personasCarouselSection.closest('.homepage-content-container') && personasCarouselSection.closest('.homepage-content-container').getAttribute('data-origin') == 'load';

        if(type == 'from-copy' && fromLoad == false){
            actionsOnVisible(personasCarouselSection, parent);
        } else if(!personasCarouselSection.closest('.homepage-content-container')) {
            actionsOnVisible(personasCarouselSection, parent);
        } else {
            const scrollHandler = function () {
            const containerRect = {top: 0, left: 0, bottom: window.innerHeight, right: window.innerWidth, width: window.innerWidth, height: window.innerHeight};
            const targetRect = personasCarouselSection.getBoundingClientRect();

            const isVisible =
                targetRect.bottom > containerRect.top &&
                targetRect.top < containerRect.bottom;

            if (
                isVisible &&
                personasCarouselSection.getAttribute("data-interacted") !== "true"
            ) {
                actionsOnVisible(personasCarouselSection, parent);
                personasCarouselSection.setAttribute("data-interacted", "true");
                window.removeEventListener("scroll", scrollHandler);
            }
        };

        window.addEventListener("scroll", scrollHandler);
        }
    }

    window.Branch.personasCarousel.personasCarouselInitOnLoad = function(type){
        let personasCarouselSections = document.querySelectorAll('.personas-carousel:not([data-initialized="true"])');
        personasCarouselSections.forEach((personasCarouselSection) => {
            let parent = personasCarouselSection.closest('.shopify-section');
            personasCarouselSection.setAttribute('data-initialized', true);
            if(type == 'from-copy'){
                 initImageCarouselCallback(personasCarouselSection, parent, type)
            } else {
                 window.Branch.functions.fireOnUserInteraction(initImageCarouselCallback, '.homepage-content-container', personasCarouselSection, personasCarouselSection, parent);
             }
        })  
    }

    if (document.readyState === "complete") {
        window.Branch.personasCarousel.personasCarouselInitOnLoad('regular'); 
    } else {
        window.addEventListener("load", () => window.Branch.personasCarousel.personasCarouselInitOnLoad('regular'));
    }
  })();
